import React, { useState, Fragment } from "react";
import { Field } from "formik";
import {
  FieldButtonGroup,
  DatePicker,
  FieldDropSide,
  SliderPanel,
  FieldInput,
  FieldInputNumber,
  FieldInputPercentage,
  AddPlans,
  CsplTable as Table,
  DifferentParticipantElectionTable,
  Link,
  WarningModal,
  FormControlSearch,
} from "../../../components";
import moment from "moment";
import { INVESTMENTS_BASED_ON, usDateFormat } from "../../../utils";
import { isEmpty, get } from "lodash";
import { useDeepEffect } from "../../../abstracts";
import { Form, Button, InputGroup, Image, Row } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashAlt } from "@fortawesome/pro-light-svg-icons";

export const DifferentInvestmentElection = (props) => {
  const {
    fields,
    isSave,
    isEdit,
    values,
    setFieldValue,
    handleChange,
    investmentList,
    sourcesList,
    setToggle,
    toggle,
    handleSubmit,
    additionalAutoEnrollmentData,
    setValues,
    deleteInvestment,
    planId,
    invetmentElectionError,
  } = props;
  const [inputFields, setInputFields] = useState([{ from: "", to: "" }]);
  const [dateFields, setDateFields] = useState([{ from: "", to: "" }]);
  const [retirementFields, setRetirementFields] = useState([
    { from: "", to: "" },
  ]);

  const errorMsg = (invsum) =>
    invsum !== 100
      ? "PL821 : The total value of investment election should not exceed or subceed 100%"
      : "";

  const [isModalOpen, setModalOpen] = useState(false);
  const [filteredResponse, setFilteredResponse] = useState({});
  const [addedInvestments, setAddedInvestments] = useState({});
  const [searchString, setSearchString] = useState("");
  const [saveInvestments, setSaveInvestments] = useState({});
  const [totalInvestments, setTotalInvestments] = useState([]);
  const [categoryIndex, setCategoryIndex] = useState(1);
  const [sourceIndex, setSourceIndex] = useState();
  const [Index, setIndex] = useState();
  const [modalVisible, setModalVisible] = useState(false);
  const handleInputChange = (index, event) => {
    if (event.target.name.includes("from")) {
      setFieldValue(
        `additionalAutoEnrollmentInvestmentElectionBasedOnList.${index}.ageFrom`,
        event.target.value
      );
    } else {
      setFieldValue(
        `additionalAutoEnrollmentInvestmentElectionBasedOnList.${index}.ageTo`,
        event.target.value
      );
    }
  };

  const handleAddAge = (from, to) => {
    handleAddFields();
  };

  const handleAddFields = () => {
    setFieldValue("additionalAutoEnrollmentInvestmentElectionBasedOnList", [
      ...values.additionalAutoEnrollmentInvestmentElectionBasedOnList.filter(
        (_) => !_.isDefaultCategory
      ),
      {
        investmentBasedOn: 1,
        ageFrom: null,
        ageTo: null,
        from: null,
        to: null,
      },
      ...values.additionalAutoEnrollmentInvestmentElectionBasedOnList.filter(
        (_) => _.isDefaultCategory
      ),
    ]);
  };

  const handleRemoveFields = (index) => {
    setFieldValue(
      "additionalAutoEnrollmentInvestmentElectionBasedOnList",
      get(
        values,
        "additionalAutoEnrollmentInvestmentElectionBasedOnList",
        []
      ).filter((_, ind) => ind !== index)
    );
  };

  const handleDateAddFields = () => {
    setFieldValue("additionalAutoEnrollmentInvestmentElectionBasedOnList", [
      ...values.additionalAutoEnrollmentInvestmentElectionBasedOnList,
      {
        investmentBasedOn: 2,
        ageFrom: null,
        ageTo: null,
        from: null,
        to: null,
      },
    ]);
  };

  const handleDateInputChange = (index, event, action) => {
    if (action === "from") {
      setFieldValue(
        `additionalAutoEnrollmentInvestmentElectionBasedOnList.${index}.from`,
        event
      );
    } else {
      setFieldValue(
        `additionalAutoEnrollmentInvestmentElectionBasedOnList.${index}.to`,
        event
      );
    }
  };

  const handleDateRemoveFields = (index) => {
    setFieldValue(
      "additionalAutoEnrollmentInvestmentElectionBasedOnList",
      get(
        values,
        "additionalAutoEnrollmentInvestmentElectionBasedOnList",
        []
      ).filter((_, ind) => ind !== index)
    );
  };

  const handleRetirementDateAddFields = () => {
    setFieldValue("additionalAutoEnrollmentInvestmentElectionBasedOnList", [
      ...values.additionalAutoEnrollmentInvestmentElectionBasedOnList,
      {
        investmentBasedOn: 3,
        ageFrom: null,
        ageTo: null,
        from: null,
        to: null,
      },
    ]);
  };

  const handleRetirementDateInputChange = (index, event, action) => {
    if (action === "from") {
      setFieldValue(
        `additionalAutoEnrollmentInvestmentElectionBasedOnList.${index}.from`,
        event
      );
    } else {
      setFieldValue(
        `additionalAutoEnrollmentInvestmentElectionBasedOnList.${index}.to`,
        event
      );
    }
  };

  const handleRetirementDateRemoveFields = (index) => {
    setFieldValue(
      "additionalAutoEnrollmentInvestmentElectionBasedOnList",
      get(
        values,
        "additionalAutoEnrollmentInvestmentElectionBasedOnList",
        []
      ).filter((_, ind) => ind !== index)
    );
  };

  let ageCat = [];
  if (
    !isEmpty(
      get(values, "additionalAutoEnrollmentInvestmentElectionBasedOnList", [])
    )
  )
    get(
      values,
      "additionalAutoEnrollmentInvestmentElectionBasedOnList",
      []
    ).map((e, i) => {
      var c = {};
      c = null;
      if (e.ageFrom && e.ageTo) {
        c = {
          label: (
            <div className="ml-2">
              {" "}
              <div>{e.ageFrom} Years </div>{" "}
              <div className="text-secondary-scss"> to</div>{" "}
              <div>{e.ageTo} Years</div>{" "}
            </div>
          ),
          className: "column-age",
          columnName: e.ageFrom + "-" + e.ageTo,
        };
        ageCat.push(c);
      }
    });

  const ageTable = [
    {
      label: "Investment",
      className: "column-investment",
      columnName: "Investment",
    },
    {
      label: "Age Group",
      className: "ageGroup",
      columnName: "ageGroup",
      isSubTable: true,
      subTable: [
        ...ageCat,
        {
          label: "Default",
          className: "column-Default",
          columnName: "Default",
        },
      ],
    },
    {
      label: "Action",
      className: "column-action",
      columnName: "Action",
    },
  ];

  const birthDateCat = [];
  if (
    !isEmpty(
      get(values, "additionalAutoEnrollmentInvestmentElectionBasedOnList", [])
    )
  )
    get(
      values,
      "additionalAutoEnrollmentInvestmentElectionBasedOnList",
      []
    ).map((e, i) => {
      var c = {};
      c = null;
      if (e.from && e.to) {
        c = {
          label: (
            <div className="ml-2">
              {" "}
              <div>{moment(e.from).format("MM/DD/YYYY")} </div>{" "}
              <div className="text-secondary-scss"> to</div>{" "}
              <div>{moment(e.to).format("MM/DD/YYYY")}</div>{" "}
            </div>
          ),
          className: "column-Birthdate",
          columnName: usDateFormat(e.from) + "-" + usDateFormat(e.to),
        };
        birthDateCat.push(c);
      }
    });

  const dateTable = [
    {
      label: "Investment",
      className: "column-investment",
      columnName: "Investment",
    },
    {
      label: "Birth Date Group",
      className: "birthDateGroup",
      columnName: "birthDateGroup",
      isSubTable: true,
      subTable: [
        ...birthDateCat,
        {
          label: "Default",
          className: "column-default",
          columnName: "Default",
        },
      ],
    },
    {
      label: "Action",
      className: "column-action",
      columnName: "Action",
    },
  ];

  const retirementCat = [];
  if (
    !isEmpty(
      get(values, "additionalAutoEnrollmentInvestmentElectionBasedOnList", [])
    )
  )
    get(
      values,
      "additionalAutoEnrollmentInvestmentElectionBasedOnList",
      []
    ).map((e, i) => {
      var c = {};
      c = null;
      if (e.from && e.to) {
        c = {
          label: (
            <div className="ml-2">
              {" "}
              <div>{moment(e.from).format("MM/DD/YYYY")} </div>{" "}
              <div className="text-secondary-scss"> to</div>{" "}
              <div>{moment(e.to).format("MM/DD/YYYY")}</div>{" "}
            </div>
          ),
          className: "column-Birthdate",
          columnName: usDateFormat(e.from) + "-" + usDateFormat(e.to),
        };
        retirementCat.push(c);
      }
    });

  const retirementTable = [
    {
      label: "Investment",
      className: "column-investment",
      columnName: "Investment",
    },
    {
      label: "Retirement Date Group",
      className: "retirementDateGroup",
      columnName: "retirementDateGroup",
      isSubTable: true,
      subTable: [
        ...retirementCat,
        {
          label: "Default",
          className: "column-default",
          columnName: "Default",
        },
      ],
    },
    {
      label: "Action",
      className: "column-action",
      columnName: "Action",
    },
  ];

  const addInvestmentsToPlan = (investment) => {
    setAddedInvestments({
      ...addedInvestments,
      [categoryIndex]: {
        ...addedInvestments[categoryIndex],
        [sourceIndex]: [
          ...(addedInvestments[categoryIndex]?.[sourceIndex] || []),
          investment,
        ],
      },
    });
  };

  const onViewButtonClick = (index, sourceind) => {
    setModalOpen(true);
    setSourceIndex(sourceind);
    setCategoryIndex(index);
  };

  const onSubmit = (savedInvestments) => {
    setSaveInvestments({
      ...saveInvestments,
      [categoryIndex]: {
        ...saveInvestments[categoryIndex],
        [sourceIndex]: savedInvestments,
      },
    });
    setModalOpen(false);
  };
  const onCancel = () => {
    if (
      addedInvestments[categoryIndex]?.[sourceIndex]?.length !=
      saveInvestments[categoryIndex]?.[sourceIndex]?.length
    ) {
      setModalVisible(true);
    } else {
      setModalOpen(false);
    }
  };
  const modalOnCancel = () => {
    setAddedInvestments({
      ...addedInvestments,
      [categoryIndex]: {
        ...addedInvestments[categoryIndex],
        [sourceIndex]: saveInvestments[categoryIndex]?.[sourceIndex],
      },
    });
    setModalOpen(false);
    setModalVisible(false);
  };
  useDeepEffect(() => {
    (sourceIndex || sourceIndex == 0) &&
      setFilteredResponse({
        ...filteredResponse,
        [categoryIndex]: {
          [sourceIndex]: investmentList.filter((team) => {
            return team.name.toLowerCase().includes(searchString.toLowerCase());
          }),
        },
      });
  }, [searchString, investmentList, categoryIndex, sourceIndex]);
  useDeepEffect(() => {
    setSaveInvestments(values.initialSavedInvestments);
  }, [values.initialSavedInvestments]);

  // useDeepEffect(() => {

  //   if (values.investmentBasedOn === 1) {
  //     setSaveInvestments({ 1: additionalAutoEnrollmentData.savedInvestments });
  //     setAddedInvestments({ 1: additionalAutoEnrollmentData.savedInvestments });

  //   } else if (values.investmentBasedOn === 2) {
  //     setSaveInvestments({ 2: additionalAutoEnrollmentData.savedInvestments });
  //     setAddedInvestments({ 2: additionalAutoEnrollmentData.savedInvestments });

  //   } else if (values.investmentBasedOn === 3) {
  //     setSaveInvestments({ 3: additionalAutoEnrollmentData.savedInvestments });
  //     setAddedInvestments({ 3: additionalAutoEnrollmentData.savedInvestments });

  //   }
  // }, [additionalAutoEnrollmentData]);

  const deletefunction = (name, index, sourceInd, cellIndex, sIndex) => {
    // var temp = totalInvestments.filter((e) => e.investmentName !== name);
    var temp = saveInvestments[index]?.[sourceInd].filter(
      (e) => e.name !== name
    );
    // setTotalInvestments(temp);
    setAddedInvestments({
      ...addedInvestments,
      [index]: {
        ...addedInvestments[index],
        [sourceInd]: temp,
      },
    });
    setSaveInvestments({
      ...saveInvestments,
      [index]: { ...addedInvestments[index], [sourceInd]: temp },
    });
    for (var i = 0; i <= index; i++) {
      if (
        values.additionalAutoEnrollmentDifferentInvestmentElection[sourceInd] !=
          null &&
        values.additionalAutoEnrollmentDifferentInvestmentElection[sourceInd][
          i
        ] != null &&
        values.additionalAutoEnrollmentDifferentInvestmentElection[sourceInd][
          i
        ][sIndex] != null
      ) {
        values.additionalAutoEnrollmentDifferentInvestmentElection[sourceInd][
          i
        ] = values.additionalAutoEnrollmentDifferentInvestmentElection[
          sourceInd
        ][i].filter((x) => x.name != name);
      }
    }
  };

  const onDeleteClick = (name, index, sourceInd, cellIndex, sIndex) => {
    //setToggle(!toggle);
    // autoEnrollment.investmentDetails
    //   ? autoEnrollment.investmentDetails.forEach((e) =>
    //       e.name === name
    //         ? deleteInvestment(planId, e.investmentId).then((response) => {
    //             if (response) deletefunction(name);
    //           })
    //         : deletefunction(name)
    //     )
    //   : deletefunction(name);
    deletefunction(name, index, sourceInd, cellIndex, sIndex);
  };
  const investmentListLength = get(
    filteredResponse,
    `${categoryIndex}.${sourceIndex}`,
    []
  ).length;
  const sliderPanel = (
    <SliderPanel isOpen={isModalOpen} size="35" showCancel={false}>
      <div className="d-flex justify-content-between align-baseline">
        <div>
          <p className="plan-heading-plan">Plan Investments</p>
          <p className="enrollment-sub-heading">
            {/* {(filteredResponse[categoryIndex]?.sourceIndex || []) */}
            {investmentListLength}{" "}
            {investmentListLength === 1
              ? "Investment Available"
              : "Investments Available"}
          </p>
        </div>
        <div>
          <Button variant="secondary" onClick={() => onCancel()}>
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={() =>
              onSubmit(addedInvestments[categoryIndex]?.[sourceIndex])
            }
            className="ml-4"
          >
            Save
          </Button>
        </div>
      </div>
      <div className="search-bar-investment">
        <Form>
          <InputGroup>
            <FormControlSearch
              size="lg"
              id="plan-search-box"
              className="plan-search-box"
              type="search"
              autoComplete="off"
              placeholder="Search Investment"
              onChange={(e) => setSearchString(e.target.value)}
            />
            {/* <InputGroup.Append>
              <InputGroup.Text className="search-bar-button">
                <Image src="/assets/icons/svg/search.svg" width="14px" />
              </InputGroup.Text>
            </InputGroup.Append> */}
          </InputGroup>
        </Form>
      </div>

      <p className="enrollment-side-content">
        {investmentListLength}{" "}
        {investmentListLength === 1
          ? "Investment Available"
          : "Investments Available"}
      </p>
      <div className="scroll-body">
        {get(filteredResponse, `${categoryIndex}.${sourceIndex}`, []) &&
          get(filteredResponse, `${categoryIndex}.${sourceIndex}`, []).map(
            (e, i) => (
              <div className="d-flex justify-content-between">
                <p>{e.name}</p>
                {(addedInvestments[categoryIndex]?.[sourceIndex] || []).find(
                  (y) => y.name === e.name
                ) ? (
                  <Button
                    size="sm"
                    style={{ width: "75px", margin: "0px 0px 8px 0px" }}
                    variant="secondary"
                    disabled
                    classname="custom-added"
                  >
                    Added
                  </Button>
                ) : (
                  <>
                    <Button
                      style={{ width: "75px", margin: "0px 0px 8px 0px" }}
                      variant="secondary"
                      onClick={() => addInvestmentsToPlan(e)}
                    >
                      Add
                    </Button>
                  </>
                )}
              </div>
            )
          )}
      </div>
    </SliderPanel>
  );

  const addInvestments = (index, sourceind) => (
    <div>
      <div className="mt-40">
        <p className="mt-20 plan-heading-plan">
          {sourcesList[sourceind].sourceName}
        </p>
        <AddPlans
          content="No Investments added."
          buttonLabel="Add Investment"
          disabled={isEdit && !isSave}
          onPrimaryClick={() => onViewButtonClick(index, sourceind)}
        />
        <p
          style={{
            display: "block",
            color: "#ff5050",
            fontSize: "0.75rem",
            marginTop: "0rem",
          }}
        >
          {get(
            invetmentElectionError,
            "investmentElectionDiffSourceDiffParticipant",
            ""
          )}
        </p>
      </div>
      {sliderPanel}
    </div>
  );
  const Invsum = (index, cellIndex) => {
    let sum1 = 0;
    if (
      !isEmpty(values.additionalAutoEnrollmentDifferentInvestmentElection) &&
      !isEmpty(
        values.additionalAutoEnrollmentDifferentInvestmentElection[index]
      ) &&
      !isEmpty(
        values.additionalAutoEnrollmentDifferentInvestmentElection[index][
          cellIndex
        ]
      )
    )
      values.additionalAutoEnrollmentDifferentInvestmentElection[index][
        cellIndex
      ].map((x) => {
        const tempInv = x?.investmentPercentage ? x?.investmentPercentage : 0;
        return (sum1 = sum1 + tempInv);
      });
    return sum1;
  };
  const AddName = (
    e,
    investmentId,
    source,
    index,
    cellIndex,
    sourceInd,
    sName,
    sourceId,
    sourceName,
    category
  ) => {
    if (
      !isEmpty(values.additionalAutoEnrollmentDifferentInvestmentElection) &&
      !isEmpty(
        values.additionalAutoEnrollmentDifferentInvestmentElection[index]
      ) &&
      !isEmpty(
        values.additionalAutoEnrollmentDifferentInvestmentElection[index][
          cellIndex
        ]
      ) &&
      !isEmpty(
        values.additionalAutoEnrollmentDifferentInvestmentElection[index][
          cellIndex
        ][sourceInd]
      )
    ) {
      //if(!isEmpty(values.autoEnrollmentSouceInvestmentElections[index].investmentElection[ind])){
      values.additionalAutoEnrollmentDifferentInvestmentElection[index][
        cellIndex
      ][sourceInd].investmentName = source;
      values.additionalAutoEnrollmentDifferentInvestmentElection[index][
        cellIndex
      ][sourceInd].investmentId = investmentId;
      values.additionalAutoEnrollmentDifferentInvestmentElection[index][
        cellIndex
      ][sourceInd].sourceName = sourceName;
      values.additionalAutoEnrollmentDifferentInvestmentElection[index][
        cellIndex
      ][sourceInd].sourceId = sourceId;
      const x = sName.split("-");
      if (category === 1 && sName !== "Default") {
        values.additionalAutoEnrollmentDifferentInvestmentElection[index][
          cellIndex
        ][sourceInd].ageFrom = x[0];
        values.additionalAutoEnrollmentDifferentInvestmentElection[index][
          cellIndex
        ][sourceInd].ageTo = x[1];
      } else if (category === 2 && sName !== "Default") {
        values.additionalAutoEnrollmentDifferentInvestmentElection[index][
          cellIndex
        ][sourceInd].birthDateFrom = x[0];
        values.additionalAutoEnrollmentDifferentInvestmentElection[index][
          cellIndex
        ][sourceInd].birthDateTo = x[1];
      } else if (category === 3 && sName !== "Default") {
        values.additionalAutoEnrollmentDifferentInvestmentElection[index][
          cellIndex
        ][sourceInd].retirementDateFrom = x[0];
        values.additionalAutoEnrollmentDifferentInvestmentElection[index][
          cellIndex
        ][sourceInd].retirementDateTo = x[1];
      }
      if (sName === "Default")
        values.additionalAutoEnrollmentDifferentInvestmentElection[index][
          cellIndex
        ][sourceInd].isDefaultCategory = true;
      // }
    }
    handleChange(e);
  };
  const investmentElectionLength = get(
    values,
    "additionalAutoEnrollmentInvestmentElectionBasedOnList",
    []
  ).length;

  const filteredInvestmentElectionLength = get(
    values,
    "additionalAutoEnrollmentInvestmentElectionBasedOnList",
    []
  ).filter((_) => _.isDefaultCategory).length;

  return (
    <div>
      <Field
        size="md"
        isRequired
        name={fields.investmentBasedOn}
        label={"Investment based on"}
        options={INVESTMENTS_BASED_ON}
        value={values[fields.investmentBasedOn]}
        selectedValue={values[fields.investmentBasedOn]}
        onChange={(value) => {
          // values.additionalAutoEnrollmentDifferentInvestmentElection = [[[{}]]];
          // // setSaveInvestments({});
          // // setInputFields({});
          // // setTotalInvestments({});
          // // setAddedInvestments({});
          // // setTotalInvestments({});
          // //values[fields.investmentBasedOn] = value;
          // setFieldValue(fields.investmentBasedOn, value);
          // setFieldValue("additionalAutoEnrollmentInvestmentElectionBasedOnList",[{
          //   investmentBasedOn:value,
          //   ageFrom: null,
          //   ageTo: null,
          //   from: null,
          //   to: null
          // }]);
          setValues({
            ...values,
            [fields.investmentBasedOn]: value,
            additionalAutoEnrollmentDifferentInvestmentElection: [[[{}]]],
            additionalAutoEnrollmentInvestmentElectionBasedOnList: [
              {
                investmentBasedOn: value,
                ageFrom: null,
                ageTo: null,
                from: null,
                to: null,
              },
            ],
          });
        }}
        component={FieldButtonGroup}
        validate={(value) => {
          return [undefined, null, ""].includes(value) ? "Required" : undefined;
        }}
        disabled={isEdit && !isSave}
      />

      {values[fields.investmentBasedOn] === 1 ? (
        <div>
          <h5>Age</h5>
          <form>
            <div className="form-row">
              {isEmpty(
                get(
                  values,
                  "additionalAutoEnrollmentInvestmentElectionBasedOnList",
                  []
                )
              )
                ? null
                : get(
                    values,
                    "additionalAutoEnrollmentInvestmentElectionBasedOnList",
                    []
                  )
                    // .filter((_) => !_.isDefaultCategory)
                    .map((inputField, index) => {
                      if (inputField.isDefaultCategory) return <></>;
                      return (
                        <Row
                          style={{
                            paddingLeft: "20px",
                          }}
                        >
                          <Fragment key={`${inputField}~${index}`}>
                            <Field
                              size="xs"
                              isRequired
                              label="From"
                              name={`age.${index}.from`}
                              placeholder="Enter age"
                              component={FieldInputNumber}
                              type="number"
                              value={inputField.ageFrom}
                              onChange={(event) =>
                                handleInputChange(index, event)
                              }
                              disabled={isEdit && !isSave}
                              autoComplete="off"
                              max={99}
                              validate={(value) => {
                                return [undefined, null, ""].includes(
                                  inputField.ageFrom
                                )
                                  ? "PL825 : Required"
                                  : parseInt(inputField.ageFrom) < 18
                                  ? "PL826 : Age should be greater than 18"
                                  : undefined;
                              }}
                            />
                            <div
                              style={{
                                marginLeft: "2rem",
                              }}
                            ></div>
                            <Field
                              size="xs"
                              isRequired
                              label="To"
                              name={`age.${index}.to`}
                              placeholder="Enter age"
                              component={FieldInputNumber}
                              type="number"
                              value={inputField.ageTo}
                              onChange={(event) =>
                                handleInputChange(index, event)
                              }
                              disabled={isEdit && !isSave}
                              autoComplete="off"
                              max={99}
                              validate={(value) => {
                                return [undefined, null, ""].includes(
                                  inputField.ageTo
                                )
                                  ? "PL828 : Required"
                                  : inputField.ageTo < inputField.ageFrom
                                  ? "PL827 : From age cannot be greater than To age"
                                  : undefined;
                              }}
                            />
                            <div className="form-group col-sm-2  investment-basedon-icons">
                              {investmentElectionLength - 1 === index && (
                                <button
                                  className="btn btn-link"
                                  type="button"
                                  onClick={() => handleAddAge()}
                                  disabled={isEdit && !isSave}
                                >
                                  +
                                </button>
                              )}
                              {((filteredInvestmentElectionLength === 0 &&
                                index !== 0) ||
                                (filteredInvestmentElectionLength !== 0 &&
                                  index !== 1)) && (
                                <button
                                  className="btn btn-link"
                                  type="button"
                                  onClick={() => {
                                    if (!(isEdit && !isSave))
                                      handleRemoveFields(index);
                                  }}
                                  disabled={isEdit && !isSave}
                                >
                                  <FontAwesomeIcon
                                    icon={faTrashAlt}
                                    color="red"
                                  />
                                </button>
                              )}
                            </div>
                          </Fragment>
                        </Row>
                      );
                    })}
            </div>
            <br />
          </form>
          <div>
            {(sourcesList || []).map((source, index) => {
              if (
                !isEmpty(saveInvestments[1]?.[index]) &&
                saveInvestments[1]?.[index][0].name != null
              ) {
                return (
                  <div>
                    <div>
                      <div className="d-flex justify-content-between align-baseline">
                        <p className="mt-20 plan-heading-plan">
                          {source.sourceName}
                        </p>
                        <Button
                          variant="secondary"
                          disabled={isEdit && !isSave}
                          onClick={() => {
                            setModalOpen(true);
                            setSourceIndex(index);
                            setCategoryIndex(1);
                          }}
                        >
                          Add Investment
                        </Button>
                      </div>
                      <div>
                        {/* <Table className="different-participants-election-table">
                          <Table.Thead>
                            <Table.Tr>
                              {ageTable.map((item, index) => {
                                return (
                                  <Table.Th
                                    key={index}
                                    className={item.className}
                                  >
                                    {item.label}
                                  </Table.Th>
                                );
                              })}
                              ;
                            </Table.Tr>
                          </Table.Thead>
                          <Table.Tbody>
                            {(saveInvestments[1]?.[index]).map(
                              (investment, sourceInd) => {
                                return (
                                  <Table.Tr key={sourceInd}>
                                    {ageTable.map((item, cellIndex) => {
                                      const fieldName = `additionalAutoEnrollmentDifferentInvestmentElection[${index}][${
                                        cellIndex - 1
                                      }][${sourceInd}].investmentPercentage`;
                                      const getContent = () => {
                                        if (item.columnName == "Investment") {
                                          return investment.name;
                                        }
                                        if (item.columnName == "Action") {
                                          return (
                                            <Link>
                                              <FontAwesomeIcon
                                                icon={faTrashAlt}
                                                color="red"
                                                onClick={() => {
                                                  if (!(isEdit && !isSave))
                                                    onDeleteClick(
                                                      investment.name,
                                                      1,
                                                      index,
                                                      cellIndex,
                                                      sourceInd
                                                    );
                                                }}
                                              />
                                            </Link>
                                          );
                                        }
                                        return (
                                          <Field
                                            size="xs"
                                            isRequired
                                            name={fieldName}
                                            hasSuggestion
                                            shouldDisplaySuggestion
                                            component={FieldInputPercentage}
                                            type="number"
                                            value={get(values, fieldName)}
                                            onChange={(e) => {
                                              AddName(
                                                e,
                                                investment.id,
                                                investment.name,
                                                index,
                                                cellIndex - 1,
                                                sourceInd,
                                                item.label,
                                                source.id,
                                                source.sourceName,
                                                1
                                              );
                                            }}
                                            disabled={isEdit && !isSave}
                                            autoComplete="off"
                                            validate={(value) => {
                                              return value === null ||
                                                value === undefined ||
                                                value === ""
                                                ? "PL545 : Required"
                                                : value === 0
                                                ? "PL546 : Allocation percentage cannot be 0"
                                                : undefined;
                                            }}
                                          />
                                        );
                                      };

                                      return (
                                        <Table.Td
                                          key={cellIndex}
                                          className={item.className}
                                        >
                                          {getContent()}
                                        </Table.Td>
                                      );
                                    })}
                                  </Table.Tr>
                                );
                              }
                            )}
                          </Table.Tbody>
                          <div className="line-separator-total" />
                          <Table.Tbody>
                            <Table.Tr>
                              {ageTable.map((item, cellIndex) => {
                                const getContent = () => {
                                  if (item.columnName == "Investment") {
                                    return "Total";
                                  }
                                  if (item.columnName == "Action") {
                                    return null;
                                  }
                                  return (
                                    <div>
                                      <Field
                                        size="xs"
                                        isRequired
                                        name="totalBox"
                                        hasSuggestion
                                        shouldDisplaySuggestion
                                        component={FieldInputPercentage}
                                        type="number"
                                        value={Invsum(index, cellIndex - 1)}
                                        autoComplete="off"
                                        disabled
                                        validate={(value) => {
                                          return Invsum(index, cellIndex - 1) !=
                                            100
                                            ? " "
                                            : undefined;
                                        }}
                                      />
                                      <p
                                        style={{
                                          display: "block",
                                          color: "#ff5050",
                                          fontSize: "0.75rem",
                                          marginTop: "0rem",
                                        }}
                                      >
                                        {errorMsg(Invsum(index, cellIndex - 1))}
                                      </p>
                                    </div>
                                  );
                                };

                                return (
                                  <Table.Td
                                    key={cellIndex}
                                    className={item.className}
                                  >
                                    {getContent()}
                                  </Table.Td>
                                );
                              })}
                            </Table.Tr>
                          </Table.Tbody>
                        </Table> */}
                        <DifferentParticipantElectionTable
                          isAdditionalAutoenrollmentDiffSource={true}
                          headerData={ageTable}
                          actualData={saveInvestments[1]?.[index]}
                          onDeleteClick={onDeleteClick}
                          errorMsg={errorMsg}
                          Invsum={Invsum}
                          AddName={AddName}
                          values={values}
                          isEdit={isEdit}
                          isSave={isSave}
                          index={index}
                          investmentBasedOn={1}
                          sourceId={source.sourceId ?? source.id}
                          sourceName={source.sourceName}
                        />
                      </div>
                    </div>
                    {sliderPanel}
                  </div>
                );
              } else {
                return addInvestments(1, index);
              }
            })}
          </div>
        </div>
      ) : null}

      {values[fields.investmentBasedOn] === 2 ? (
        <>
          <h5>Birth date</h5>
          <form>
            <div className="form-row">
              {get(
                values,
                "additionalAutoEnrollmentInvestmentElectionBasedOnList",
                []
              ).map((inputField, index) => {
                if (inputField.isDefaultCategory) return <></>;
                return (
                  <Row
                    style={{
                      paddingLeft: "20px",
                    }}
                  >
                    <Fragment key={`${inputField}~${index}`}>
                      <Field
                        isRequired
                        label="From"
                        size="md"
                        name={`birthDate.${index}.from`}
                        value={usDateFormat(inputField.from)}
                        placeholder="Select Birthdate"
                        isDatePicker
                        popupContent={
                          <DatePicker
                            onDayClick={(value) =>
                              handleDateInputChange(index, value, "from")
                            }
                            value={usDateFormat(values[fields.birthDateFrom])}
                          />
                        }
                        component={FieldDropSide}
                        disabled={isEdit && !isSave}
                        validate={(value) => {
                          return [undefined, null, ""].includes(inputField.from)
                            ? "PL831 : Required"
                            : undefined;
                        }}
                        onClear={() =>
                          setFieldValue(
                            `additionalAutoEnrollmentInvestmentElectionBasedOnList.${index}.from`,
                            null
                          )
                        }
                      />
                      <div
                        style={{
                          marginLeft: "2rem",
                        }}
                      ></div>
                      <Field
                        isRequired
                        label="To"
                        size="md"
                        name={`birthDate.${index}.to`}
                        value={usDateFormat(inputField.to)}
                        placeholder="Select Birthdate"
                        isDatePicker
                        popupContent={
                          <DatePicker
                            onDayClick={(value) =>
                              handleDateInputChange(index, value, "To")
                            }
                            value={usDateFormat(values[fields.birthDateTo])}
                          />
                        }
                        component={FieldDropSide}
                        disabled={isEdit && !isSave}
                        validate={(value) => {
                          return [undefined, null, ""].includes(inputField.to)
                            ? "PL833 : Required"
                            : inputField.to < inputField.from
                            ? "PL832 : From date cannot be greater than To date"
                            : undefined;
                        }}
                        onClear={() =>
                          setFieldValue(
                            `additionalAutoEnrollmentInvestmentElectionBasedOnList.${index}.to`,
                            null
                          )
                        }
                      />
                      <div className="form-group investment-basedon-icons">
                        {investmentElectionLength - 1 === index && (
                          <button
                            className="btn btn-link"
                            type="button"
                            onClick={() => handleDateAddFields()}
                            disabled={isEdit && !isSave}
                          >
                            +
                          </button>
                        )}
                        {((filteredInvestmentElectionLength === 0 &&
                          index !== 0) ||
                          (filteredInvestmentElectionLength !== 0 &&
                            index !== 1)) && (
                          <button
                            className="btn btn-link"
                            type="button"
                            onClick={() => {
                              if (!(isEdit && !isSave))
                                handleDateRemoveFields(index);
                            }}
                            disabled={isEdit && !isSave}
                          >
                            <FontAwesomeIcon icon={faTrashAlt} color="red" />
                          </button>
                        )}
                      </div>
                    </Fragment>
                  </Row>
                );
              })}
            </div>
            <br />
          </form>

          <div>
            {(sourcesList || []).map((source, index) => {
              if (
                !isEmpty(saveInvestments[2]?.[index]) &&
                saveInvestments[2]?.[index][0].name != null
              ) {
                return (
                  <div>
                    <div>
                      <div className="d-flex justify-content-between align-baseline">
                        <p className="mt-20 plan-heading-plan">
                          {source.sourceName}
                        </p>
                        <Button
                          variant="secondary"
                          disabled={isEdit && !isSave}
                          onClick={() => {
                            setModalOpen(true);
                            setSourceIndex(index);
                            setCategoryIndex(2);
                          }}
                        >
                          Add Investment
                        </Button>
                      </div>
                      <div>
                        {/* <Table className="different-participants-election-table">
                          <Table.Thead>
                            <Table.Tr>
                              {dateTable.map((item, index) => {
                                return (
                                  <Table.Th
                                    key={index}
                                    className={item.className}
                                  >
                                    {item.label}
                                  </Table.Th>
                                );
                              })}
                            </Table.Tr>
                          </Table.Thead>
                          <Table.Tbody>
                            {(saveInvestments[2]?.[index]).map(
                              (investment, sourceInd) => {
                                return (
                                  <Table.Tr key={sourceInd}>
                                    {dateTable.map((item, cellIndex) => {
                                      const fieldName = `additionalAutoEnrollmentDifferentInvestmentElection[${index}][${
                                        cellIndex - 1
                                      }][${sourceInd}].investmentPercentage`;
                                      // "2" +
                                      // index +
                                      // "ID" +
                                      // cellIndex +
                                      // investment.name;
                                      const getContent = () => {
                                        if (item.columnName == "Investment") {
                                          return investment.name;
                                        }
                                        if (item.columnName == "Action") {
                                          return (
                                            <Link>
                                              <FontAwesomeIcon
                                                icon={faTrashAlt}
                                                color="red"
                                                onClick={() => {
                                                  if (!(isEdit && !isSave))
                                                    onDeleteClick(
                                                      investment.name,
                                                      2,
                                                      index,
                                                      cellIndex,
                                                      sourceInd
                                                    );
                                                }}
                                              />
                                            </Link>
                                          );
                                        }
                                        return (
                                          <Field
                                            size="xs"
                                            isRequired
                                            name={fieldName}
                                            hasSuggestion
                                            shouldDisplaySuggestion
                                            component={FieldInputPercentage}
                                            type="number"
                                            value={get(values, fieldName)}
                                            onChange={(e) => {
                                              AddName(
                                                e,
                                                investment.id,
                                                investment.name,
                                                index,
                                                cellIndex - 1,
                                                sourceInd,
                                                item.label,
                                                source.id,
                                                source.sourceName,
                                                2
                                              );
                                            }}
                                            disabled={isEdit && !isSave}
                                            autoComplete="off"
                                            validate={(value) => {
                                              return value === null ||
                                                value === undefined ||
                                                value === ""
                                                ? "PL545 : Required"
                                                : value === 0
                                                ? "PL546 : Allocation percentage cannot be 0"
                                                : undefined;
                                            }}
                                          />
                                        );
                                      };

                                      return (
                                        <Table.Td
                                          key={cellIndex}
                                          className={item.className}
                                        >
                                          {getContent()}
                                        </Table.Td>
                                      );
                                    })}
                                  </Table.Tr>
                                );
                              }
                            )}
                          </Table.Tbody>
                          <div className="line-separator-total" />
                          <Table.Tbody>
                            <Table.Tr>
                              {dateTable.map((item, cellIndex) => {
                                const getContent = () => {
                                  if (item.columnName == "Investment") {
                                    return "Total";
                                  }
                                  if (item.columnName == "Action") {
                                    return null;
                                  }
                                  return (
                                    <div>
                                      <Field
                                        size="xs"
                                        isRequired
                                        name="totalBox"
                                        hasSuggestion
                                        shouldDisplaySuggestion
                                        component={FieldInputPercentage}
                                        type="number"
                                        value={Invsum(index, cellIndex - 1)}
                                        autoComplete="off"
                                        disabled
                                        validate={(value) => {
                                          return Invsum(index, cellIndex - 1) !=
                                            100
                                            ? " "
                                            : undefined;
                                        }}
                                      />
                                      <p
                                        style={{
                                          display: "block",
                                          color: "#ff5050",
                                          fontSize: "0.75rem",
                                          marginTop: "0rem",
                                        }}
                                      >
                                        {errorMsg(Invsum(index, cellIndex - 1))}
                                      </p>
                                    </div>
                                  );
                                };

                                return (
                                  <Table.Td
                                    key={cellIndex}
                                    className={item.className}
                                  >
                                    {getContent()}
                                  </Table.Td>
                                );
                              })}
                            </Table.Tr>
                          </Table.Tbody>
                        </Table> */}
                        <DifferentParticipantElectionTable
                          isAdditionalAutoenrollmentDiffSource={true}
                          headerData={dateTable}
                          actualData={saveInvestments[2]?.[index]}
                          onDeleteClick={onDeleteClick}
                          errorMsg={errorMsg}
                          Invsum={Invsum}
                          AddName={AddName}
                          values={values}
                          isEdit={isEdit}
                          isSave={isSave}
                          index={index}
                          investmentBasedOn={2}
                          sourceId={source.sourceId ?? source.id}
                          sourceName={source.sourceName}
                        />
                      </div>
                    </div>
                    {sliderPanel}
                  </div>
                );
              } else {
                return addInvestments(2, index);
              }
            })}
          </div>
        </>
      ) : null}

      {values[fields.investmentBasedOn] === 3 ? (
        <>
          <h5>RetirementDate</h5>
          <form>
            <div className="form-row">
              {get(
                values,
                "additionalAutoEnrollmentInvestmentElectionBasedOnList",
                []
              ).map((inputField, index) => {
                if (inputField.isDefaultCategory) return <></>;
                return (
                  <Row
                    style={{
                      paddingLeft: "20px",
                    }}
                  >
                    <Fragment key={`${inputField}~${index}`}>
                      <Field
                        isRequired
                        label="From"
                        size="md"
                        name={`retirement.${index}.from`}
                        value={usDateFormat(inputField.from)}
                        placeholder="Select Birthdate"
                        isDatePicker
                        popupContent={
                          <DatePicker
                            onDayClick={(value) =>
                              handleRetirementDateInputChange(
                                index,
                                value,
                                "from"
                              )
                            }
                            value={usDateFormat(
                              values[fields.RetirementDateFrom]
                            )}
                          />
                        }
                        validate={(value) => {
                          return [undefined, null, ""].includes(inputField.from)
                            ? "PL835 : Required"
                            : undefined;
                        }}
                        component={FieldDropSide}
                        disabled={isEdit && !isSave}
                        onClear={() =>
                          setFieldValue(
                            `additionalAutoEnrollmentInvestmentElectionBasedOnList.${index}.from`,
                            null
                          )
                        }
                      />
                      <div
                        style={{
                          marginLeft: "2rem",
                        }}
                      ></div>
                      <Field
                        isRequired
                        label="To"
                        size="md"
                        name={`retirement.${index}.to`}
                        value={usDateFormat(inputField.to)}
                        placeholder="Select Birthdate"
                        isDatePicker
                        popupContent={
                          <DatePicker
                            onDayClick={(value) =>
                              handleRetirementDateInputChange(
                                index,
                                value,
                                "To"
                              )
                            }
                            value={usDateFormat(
                              values[fields.RetirementDateTo]
                            )}
                          />
                        }
                        component={FieldDropSide}
                        validate={(value) => {
                          return [undefined, null, ""].includes(inputField.to)
                            ? "PL837 : Required"
                            : inputField.to < inputField.from
                            ? "PL836 : From date cannot be greater than To date"
                            : undefined;
                        }}
                        disabled={isEdit && !isSave}
                        onClear={() =>
                          setFieldValue(
                            `additionalAutoEnrollmentInvestmentElectionBasedOnList.${index}.to`,
                            null
                          )
                        }
                      />
                      <div className="form-group investment-basedon-icons">
                        {investmentElectionLength - 1 === index && (
                          <button
                            className="btn btn-link"
                            type="button"
                            onClick={() => handleRetirementDateAddFields()}
                            disabled={isEdit && !isSave}
                          >
                            +
                          </button>
                        )}
                        {((filteredInvestmentElectionLength === 0 &&
                          index !== 0) ||
                          (filteredInvestmentElectionLength !== 0 &&
                            index !== 1)) && (
                          <button
                            className="btn btn-link"
                            type="button"
                            onClick={() => {
                              if (!(isEdit && !isSave))
                                handleRetirementDateRemoveFields(index);
                            }}
                            disabled={isEdit && !isSave}
                          >
                            <FontAwesomeIcon icon={faTrashAlt} color="red" />
                          </button>
                        )}
                      </div>
                    </Fragment>
                  </Row>
                );
              })}
            </div>
            <br />
          </form>

          <div>
            {(sourcesList || []).map((source, index) => {
              if (
                !isEmpty(saveInvestments[3]?.[index]) &&
                saveInvestments[3]?.[index][0].name != null
              ) {
                return (
                  <div>
                    <div>
                      <div className="d-flex justify-content-between align-baseline">
                        <p className="mt-20 plan-heading-plan">
                          {source.sourceName}
                        </p>
                        <Button
                          variant="secondary"
                          disabled={isEdit && !isSave}
                          onClick={() => {
                            setModalOpen(true);
                            setSourceIndex(index);
                            setCategoryIndex(3);
                          }}
                        >
                          Add Investment
                        </Button>
                      </div>
                      <div>
                        {/* <Table className="different-participants-election-table">
                          <Table.Thead>
                            <Table.Tr>
                              {retirementTable.map((item, index) => {
                                return (
                                  <Table.Th
                                    key={index}
                                    className={item.className}
                                  >
                                    {item.label}
                                  </Table.Th>
                                );
                              })}
                            </Table.Tr>
                          </Table.Thead>
                          <Table.Tbody>
                            {(saveInvestments[3]?.[index]).map(
                              (investment, sourceInd) => {
                                return (
                                  <Table.Tr key={sourceInd}>
                                    {retirementTable.map((item, cellIndex) => {
                                      const fieldName = `additionalAutoEnrollmentDifferentInvestmentElection[${index}][${
                                        cellIndex - 1
                                      }][${sourceInd}].investmentPercentage`;
                                      // "3" +
                                      // index +
                                      // "ID" +
                                      // cellIndex +
                                      // investment.name;
                                      const getContent = () => {
                                        if (item.columnName == "Investment") {
                                          return investment.name;
                                        }
                                        if (item.columnName == "Action") {
                                          return (
                                            <Link>
                                              <FontAwesomeIcon
                                                icon={faTrashAlt}
                                                color="red"
                                                onClick={() => {
                                                  if (!(isEdit && !isSave))
                                                    onDeleteClick(
                                                      investment.name,
                                                      3,
                                                      index,
                                                      cellIndex
                                                    );
                                                }}
                                              />
                                            </Link>
                                          );
                                        }
                                        return (
                                          <Field
                                            size="xs"
                                            isRequired
                                            name={fieldName}
                                            hasSuggestion
                                            shouldDisplaySuggestion
                                            component={FieldInputPercentage}
                                            type="number"
                                            value={get(values, fieldName)}
                                            onChange={(e) => {
                                              AddName(
                                                e,
                                                investment.id,
                                                investment.name,
                                                index,
                                                cellIndex - 1,
                                                sourceInd,
                                                item.label,
                                                source.id,
                                                source.sourceName,
                                                3
                                              );
                                            }}
                                            disabled={isEdit && !isSave}
                                            autoComplete="off"
                                            validate={(value) => {
                                              return value === null ||
                                                value === undefined ||
                                                value === ""
                                                ? "PL545 : Required"
                                                : value === 0
                                                ? "PL546 : Allocation percentage cannot be 0"
                                                : undefined;
                                            }}
                                          />
                                        );
                                      };

                                      return (
                                        <Table.Td
                                          key={cellIndex}
                                          className={item.className}
                                        >
                                          {getContent()}
                                        </Table.Td>
                                      );
                                    })}
                                  </Table.Tr>
                                );
                              }
                            )}
                          </Table.Tbody>
                          <div className="line-separator-total" />
                          <Table.Tbody>
                            <Table.Tr>
                              {retirementTable.map((item, cellIndex) => {
                                const getContent = () => {
                                  if (item.columnName == "Investment") {
                                    return "Total";
                                  }
                                  if (item.columnName == "Action") {
                                    return null;
                                  }
                                  return (
                                    <div>
                                      <Field
                                        size="xs"
                                        isRequired
                                        name="totalBox"
                                        hasSuggestion
                                        shouldDisplaySuggestion
                                        component={FieldInputPercentage}
                                        type="number"
                                        value={Invsum(index, cellIndex - 1)}
                                        autoComplete="off"
                                        disabled
                                        validate={(value) => {
                                          return Invsum(index, cellIndex - 1) !=
                                            100
                                            ? " "
                                            : undefined;
                                        }}
                                      />{" "}
                                      <p
                                        style={{
                                          display: "block",
                                          color: "#ff5050",
                                          fontSize: "0.75rem",
                                          marginTop: "0rem",
                                        }}
                                      >
                                        {errorMsg(Invsum(index, cellIndex - 1))}
                                      </p>
                                    </div>
                                  );
                                };

                                return (
                                  <Table.Td
                                    key={cellIndex}
                                    className={item.className}
                                  >
                                    {getContent()}
                                  </Table.Td>
                                );
                              })}
                            </Table.Tr>
                          </Table.Tbody>
                        </Table> */}
                        <DifferentParticipantElectionTable
                          isAdditionalAutoenrollmentDiffSource={true}
                          headerData={retirementTable}
                          actualData={saveInvestments[3]?.[index]}
                          onDeleteClick={onDeleteClick}
                          errorMsg={errorMsg}
                          Invsum={Invsum}
                          AddName={AddName}
                          values={values}
                          isEdit={isEdit}
                          isSave={isSave}
                          index={index}
                          investmentBasedOn={3}
                          sourceId={source.sourceId ?? source.id}
                          sourceName={source.sourceName}
                        />
                      </div>
                    </div>
                    {sliderPanel}
                  </div>
                );
              } else {
                return addInvestments(3, index);
              }
            })}
          </div>
        </>
      ) : null}
      <WarningModal show={modalVisible} onHide={() => setModalVisible(false)}>
        <div className="remove-text">
          <h4>Are you sure?</h4>
          <p>Your changes may be lost. Do you want to continue ?</p>
          <Button
            type="button"
            className="remove-btn mr-4"
            onClick={() => modalOnCancel()}
          >
            Yes
          </Button>
          <Button className="cancel-btn" onClick={() => setModalVisible(false)}>
            No
          </Button>
        </div>
      </WarningModal>
    </div>
  );
};

export default DifferentInvestmentElection;
